// Import third-party libraries with Webpack
// var jQuery = require('jquery');
// Comment previous line and uncomment the next if you want to use jQuery globally
require("expose-loader?jQuery!jquery");
import 'bootstrap';
